import { d as o, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as r, createElementBlock as s, normalizeClass as n, normalizeStyle as a, createElementVNode as l } from "vue";
const c = o("arrow-right2"), i = /* @__PURE__ */ l("path", {
  d: "M312.38 132.53a84.855 84.855 0 1 1 144.254-89.183L704.919 445.39a127.282 127.282 0 0 1 0 133.731L456.634 981.077a84.855 84.855 0 1 1-144.253-89.182L546.665 512.17C468.683 385.65 390.447 259.133 312.38 132.53",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, h, w) {
  return r(), s("svg", {
    class: n(e.classes),
    style: a(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const v = /* @__PURE__ */ t(c, [["render", m]]);
export {
  v as default
};
